import type { MultiSelectOption } from "../../MultiSelect";
import type { ClientTypeFilterValue } from "./clientTypeFilter";

import { FilterButtonGroup } from "../../FilterButtonGroup";
import { MultiSelect } from "../../MultiSelect";
import { TextButton } from "../../TextButton";
import { Typo } from "../../Typo";
import { FilterField } from "../Common/FilterField";
import { includesSharedClients } from "./clientTypeFilter";
import { useClientTypeFilterTranslate } from "./useClientTypeFilterTranslate";

export * from "./clientTypeFilter";

const TEST_IDS = {
  modal: {
    clientType: "clients_filter_modal_client_type",
    subIB: "clients_filter_modal_sub_ib_select",
    retry: "clients_filter_modal_sub_ib_retry_button",
  },
  mobile: {
    clientType: "clients_filter_mobile_client_type",
    subIB: "clients_filter_mobile_sub_ib_select",
    retry: "clients_filter_mobile_sub_ib_retry_button",
  },
};

export type ClientTypeFilterFieldsProps = {
  context?: keyof typeof TEST_IDS;
  clientTypes: ClientTypeFilterValue[];
  onClientTypesChange: (clientTypes: ClientTypeFilterValue[]) => void;
  subIBOptions: MultiSelectOption[];
  selectedSubIBs: MultiSelectOption[];
  onSubIBsChange: (subIBs: MultiSelectOption[]) => void;
  subIBsLoadFailed?: boolean;
  onRetrySubIBs?: () => void;
};

export const ClientTypeFilterFields = ({
  context = "modal",
  clientTypes,
  onClientTypesChange,
  subIBOptions,
  selectedSubIBs,
  onSubIBsChange,
  subIBsLoadFailed = false,
  onRetrySubIBs,
}: ClientTypeFilterFieldsProps) => {
  const translations = useClientTypeFilterTranslate();
  const testIds = TEST_IDS[context];

  return (
    <>
      <FilterButtonGroup<ClientTypeFilterValue>
        label={translations.clientTypeLabel}
        options={[
          { label: translations.directClients, value: "direct" },
          { label: translations.sharedWithSubIB, value: "indirect" },
        ]}
        values={clientTypes}
        onChange={onClientTypesChange}
        data-testid={testIds.clientType}
      />
      {includesSharedClients(clientTypes) && (
        <FilterField
          label={translations.subIBLabel}
          hint={translations.subIBHint}
        >
          {(controlProps) =>
            subIBsLoadFailed ? (
              <div className="flex items-center gap-2">
                <div role="alert" className="flex-1">
                  <Typo element="p" type="bodySM" textColor="text-text-error">
                    {translations.subIBLoadError}
                  </Typo>
                </div>
                {onRetrySubIBs && (
                  <TextButton
                    size="xs"
                    underlined
                    onClick={onRetrySubIBs}
                    data-testid={testIds.retry}
                  >
                    {translations.retry}
                  </TextButton>
                )}
              </div>
            ) : (
              <MultiSelect
                modal
                id={`subIBFilter-${context}`}
                options={subIBOptions}
                selected={selectedSubIBs}
                onChange={onSubIBsChange}
                placeholder={translations.subIBPlaceholder}
                data-testid={testIds.subIB}
                {...controlProps}
              />
            )
          }
        </FilterField>
      )}
    </>
  );
};
